import { DataGrid } from "@mui/x-data-grid";
import {
  CmpTypographyField,
  CmpDatePickerField,
  CmpSelectField,
  CmpSelectArrField,
  CmpInputField,
} from "../../../Component/Common/ToolBox/ToolBox";
import { hasValueInErrorMessage } from "../../../Utility/Utilitys";

import Grid from "@mui/material/Grid";
import { CmpDatePickerField001V1, CmpSelectArrFieldV1, CmpSelectFieldV1, CmpTextFieldV1 } from "../../../Component/Common/ToolBox/ToolBoxV1";
export default function GCHead({
  vMediaQuery,
  //grid saleshistory end
  vRdxWmsHead,
  sDocLoadingGrnType,
  sType,
  sTax,
  sTransferType,
  fonSelectedGrnType,
  fGrnDate,
  fInvDate,
  fType,
  fTax,
  fTransferType,
  fFromLocation,
  fToLocation,
  fCreditLimit,
  fOsAmount,
  fAvlAmt,
  xKey,
  xFocusInput,
  sFromLocation,
  sToLocation,
  xErrorMsg,
  xDisableBasedOnGridDataLength,
  inputFocus,
  sBufferItmCd,
  headGridShow,
  sHeadGridColumn,
  sHeadGridRow,
}) {
  return (
    <form id="WmsStockTransferHead">
      <Grid
        container
        rowSpacing={{ xs: 0.9, sm: 0.9, md: 0.9 }}
        columnSpacing={{ xs: 0.9, sm: 0.9, md: 1 }}
        columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
      >
        <Grid
          item
          xs={12}
          sm={12}
          md={5}
          lg={5}
          // className={vMediaQuery ? "" : "pe-5"}
        >
          <Grid
            container
            spacing={0.9}
            columns={{ xs: 12, sm: 12, md: 12 }}
            className={
              hasValueInErrorMessage(xErrorMsg)
                ? "align-items-center"
                : "align-items-start"
            }
          >
           
            <Grid item xs={12} sm={6} md={6}  >
              <CmpSelectFieldV1
                xtabIndex={"1"}
                xLabelText="Doc.Type"
                xValue={vRdxWmsHead.A_VocTyp}
                xOnChange={fonSelectedGrnType}
                xName={"A_VocTyp"}
                xData={sDocLoadingGrnType}
                xValueMember={""}
                xDispalyMember={""}
                xError={xErrorMsg.A_VocTyp === "" ? false : true}
                xErrorMessage={xErrorMsg.A_VocTyp}
                xDisable={
                  xDisableBasedOnGridDataLength || vRdxWmsHead.A_VocNo != 0
                }
                // xOnKeyUp={xKey}
              />
            </Grid>
           
            <Grid item xs={6} sm={6} md={6}  >
              <CmpTextFieldV1
                             xLabelText="Doc.No"
                xValue={vRdxWmsHead.A_VocNo}
                xType={"text"} // text/number/password
                xName={"A_VocNo"}
                xReadOnly={true}
                xOnChange={""}
                xError={xErrorMsg.A_VocNo === "" ? false : true}
                xErrorMessage={xErrorMsg.A_VocNo}
                xOnKeyUp={xKey}
              />
            </Grid>
       
            <Grid item xs={6} sm={6} md={6}  >
             <CmpDatePickerField001V1
                              xLabelText="Ref.Date"
                xtabIndex={"2"}
                xValue={vRdxWmsHead.A_RefDt}
                xOnChange={fInvDate}
                xName={"A_RefDt"}
                xError={xErrorMsg.A_RefDt === "" ? false : true}
                xErrorMessage={xErrorMsg.A_RefDt}
                // xOnKeyUp={(e) => {
                //   xFocusInput("Paymode");
                // }}
              />
            </Grid>
            
            <Grid item xs={6} sm={6} md={6}  >
              <CmpDatePickerField001V1
                              xLabelText="Doc.Date"
                xtabIndex={"3"}
                // xValue={vRdxWmsHead.A_PostDt}
                xValue={vRdxWmsHead.A_PostDt}
                xOnChange={fGrnDate}
                xName={"A_PostDt"}
                xError={xErrorMsg.A_PostDt === "" ? false : true}
                xErrorMessage={xErrorMsg.A_PostDt}
              />
            </Grid>

             
            <Grid item xs={6} sm={6} md={6}  >
              <CmpSelectArrFieldV1
                xLabelText="Type"
                xValue={vRdxWmsHead.A_Type}
                xOnChange={fType}
                xName={"A_Type"}
                xData={sType}
                xValueMember={""}
                xDispalyMember={""}
                xError={xErrorMsg.A_Type === "" ? false : true}
                xErrorMessage={xErrorMsg.A_Type}
                xDisable={xDisableBasedOnGridDataLength || sBufferItmCd}
                xtabIndex={"4"}
              />
            </Grid>
          </Grid>
        </Grid>
        {!headGridShow &&
        <Grid item xs={12} sm={12} md={7} lg={7}>
          <Grid
            container
            spacing={0.9}
            columnSpacing={{ xs: 0.9, sm: 0.9, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            className={
              hasValueInErrorMessage(xErrorMsg)
                ? "align-items-center"
                : "align-items-start"
            }
          >
             
            <Grid item xs={6} sm={6} md={3}  >
              <CmpSelectFieldV1
                xtabIndex={"5"}
                xLabelText="From Location"
                xValue={vRdxWmsHead.A_FromLoc}
                xOnChange={fFromLocation}
                xName={"A_FromLoc"}
                xData={sFromLocation}
                xValueMember={""}
                xDispalyMember={""}
                xError={xErrorMsg.A_FromLoc === "" ? false : true}
                xErrorMessage={xErrorMsg.A_FromLoc}
                xDisable={xDisableBasedOnGridDataLength || sBufferItmCd}
              />
            </Grid>
 
            <Grid item xs={6} sm={6} md={3}  >
             <CmpTextFieldV1
               xLabelText="From Trn.#"
                xtabIndex={"6"}
                xValue={vRdxWmsHead.A_FromTrn}
                xType={"text"} // text/number/password
                xName={"A_FromTrn"}
                xReadOnly={true}
                xError={xErrorMsg.A_FromTrn === "" ? false : true}
                xErrorMessage={xErrorMsg.A_FromTrn}
                // xOnKeyUp={(e) => {
                //   xFocusInput("A_LocName");
                // }}
              />
            </Grid>
           
            <Grid item xs={6} sm={6} md={3}  >
              <CmpSelectFieldV1
                xtabIndex={"7"}
                xLabelText="To Location"
                xValue={vRdxWmsHead.A_ToLoc}
                xOnChange={fToLocation}
                xName={"A_ToLoc"}
                xData={sToLocation}
                xValueMember={""}
                xDispalyMember={""}
                xError={xErrorMsg.A_ToLoc === "" ? false : true}
                xErrorMessage={xErrorMsg.A_ToLoc}
                xDisable={xDisableBasedOnGridDataLength || sBufferItmCd}
              />
            </Grid>

            
            <Grid item xs={6} sm={6} md={3}  >
              <CmpTextFieldV1
               xLabelText="To Trn.#"
                xtabIndex={"8"}
                xValue={vRdxWmsHead.A_ToTrn}
                xType={"text"} // text/number/password
                xName={"A_ToTrn"}
                xReadOnly={true}
                xError={xErrorMsg.A_ToTrn === "" ? false : true}
                xErrorMessage={xErrorMsg.A_ToTrn}
                // xOnKeyUp={(e) => {
                //   xFocusInput("A_LocName");
                // }}
              />
            </Grid>
            
            <Grid item xs={12} sm={8} md={8}  >
              <Grid container spacing={0.9}>
                <Grid item xs={3} sm={3} md={3} >
                  <CmpTextFieldV1
                     xLabelText="Party"
                    xValue={vRdxWmsHead.A_Party}
                    xType={"text"} // text/number/password
                    xName={"A_Party"}
                    xReadOnly={true}
                    xOnChange={""}
                    xError={xErrorMsg.A_Party === "" ? false : true}
                    xErrorMessage={xErrorMsg.A_Party}
                  />
                </Grid>
                <Grid item xs={9} sm={9} md={9}  >
                   <CmpTextFieldV1
                     xLabelText="Party Name"
                    xtabIndex={"9"}
                    xValue={vRdxWmsHead.A_PartyName}
                    xType={"text"} // text/number/password
                    xName={"CreditLimit"}
                    xReadOnly={true}
                    xError={xErrorMsg.A_PartyName === "" ? false : true}
                    xErrorMessage={xErrorMsg.A_PartyName}
                    // xOnKeyUp={(e) => {
                    //   xFocusInput("A_LocName");
                    // }}
                  />
                </Grid>
              </Grid>
            </Grid>
            {/* <Grid item xs={3} sm={2} md={2} >
              <CmpInputField
                xValue={vRdxWmsHead.A_Party}
                xType={"text"} // text/number/password
                xName={"A_Party"}
                xReadOnly={true}
                xOnChange={""}
                xError={xErrorMsg.A_Party === "" ? false : true}
                xErrorMessage={xErrorMsg.A_Party}
              />
            </Grid>
            <Grid item xs={6} sm={8} md={3}   >
              <CmpInputField
                xtabIndex={"9"}
                xValue={vRdxWmsHead.A_PartyName}
                xType={"text"} // text/number/password
                xName={"CreditLimit"}
                xReadOnly={true}
                xError={xErrorMsg.A_PartyName === "" ? false : true}
                xErrorMessage={xErrorMsg.A_PartyName}
                // xOnKeyUp={(e) => {
                //   xFocusInput("A_LocName");
                // }}
              />
            </Grid> */}

            
            <Grid item xs={6} sm={4} md={2}  >
               <CmpTextFieldV1
               xLabelText="CreditLimit"
                xtabIndex={"10"}
                xValue={vRdxWmsHead.CreditLimit}
                xType={"number"} // text/number/password
                xName={"CreditLimit"}
                xReadOnly={true}
                xOnChange={fCreditLimit}
                xError={xErrorMsg.CreditLimit === "" ? false : true}
                xErrorMessage={xErrorMsg.CreditLimit}
                // xOnKeyUp={(e) => {
                //   xFocusInput("A_LocName");
                // }}
              />
            </Grid>
            
            <Grid item xs={6} sm={4} md={2}  >
              <CmpTextFieldV1
               xLabelText="OsAmount"
                xtabIndex={"11"}
                xValue={vRdxWmsHead.OsAmount}
                xType={"number"} // text/number/password
                xName={"OsAmount"}
                xReadOnly={true}
                xOnChange={fOsAmount}
                xError={xErrorMsg.OsAmount === "" ? false : true}
                xErrorMessage={xErrorMsg.OsAmount}
                // xOnKeyUp={(e) => {
                //   xFocusInput("A_LocName");
                // }}
              />
            </Grid>
             
            <Grid item xs={6} sm={4} md={2} >
            <CmpTextFieldV1
               xLabelText="Avl.Amt"
                xtabIndex={"12"}
                xValue={vRdxWmsHead.AvlAmt}
                xType={"number"} // text/number/password
                xName={"AvlAmt"}
                xReadOnly={true}
                xOnChange={fAvlAmt}
                xError={xErrorMsg.AvlAmt === "" ? false : true}
                xErrorMessage={xErrorMsg.AvlAmt}
                // xOnKeyUp={(e) => {
                //   xFocusInput("A_LocName");
                // }}
              />
            </Grid>

         
            <Grid item xs={6} sm={4} md={3}  >
              <CmpSelectFieldV1
                xtabIndex={"13"}
                xLabelText="Tax"
                xValue={vRdxWmsHead.TaxType}
                xOnChange={fTax}
                xName={"TaxType"}
                xData={sTax}
                xValueMember={""}
                xDispalyMember={""}
                xError={xErrorMsg.TaxType === "" ? false : true}
                xErrorMessage={xErrorMsg.TaxType}
                xDisable={true}
              />
            </Grid>
            
            <Grid item xs={6} sm={4} md={3}  >
              <CmpSelectFieldV1
                xtabIndex={"14"}
                xLabelText="Transfer Type"
                xValue={vRdxWmsHead.TransferType}
                xOnChange={fTransferType}
                xName={"TransferType"}
                xData={sTransferType}
                xValueMember={""}
                xDispalyMember={""}
                xError={xErrorMsg.TransferType === "" ? false : true}
                xErrorMessage={xErrorMsg.TransferType}
                xDisable={xDisableBasedOnGridDataLength}
              />
            </Grid>
          </Grid>
        </Grid>}
       { headGridShow &&
        <Grid item xs={12} sm={12} md={7} lg={7}>
          <div style={{ height: "150px", width: "100%" }}>
            <DataGrid
              rowHeight={30}
              headerHeight={40}
              getRowClassName={(params) =>
                params.indexRelativeToCurrentPage % 2 === 0
                  ? "mui-even-row"
                  : "mui-odd-row"
              }
              sx={{
                border: 1,
                borderColor: "primary.light",
              }}
              rows={sHeadGridRow}
              columns={sHeadGridColumn}
              onRowClick={() => {}}
              hideFooter={sHeadGridRow.length < 100}
              // components={{
              //   Toolbar: GridToolbar,
              // }}
            />
          </div>
        </Grid>}
      </Grid>
    </form>
  );
}
